import { TypePolicies } from '@apollo/client';

const fetchQuotationUserGNBCache: TypePolicies = {
  Query: {
    fields: {
      fetchQuotationUserGNB: {
        keyArgs: false,
        merge: true
      }
    }
  }
};

export default fetchQuotationUserGNBCache;
